<template>
  <div class="doomyogalogin doomyoga-auth-container">
    <div class="h-100">
      <div class="row h-100 m-0 authRowContainer">
        <div
          class="
            col-xl-5 col-lg-5 col-md-6 col-sm-12
            my-md-auto my-1
            order-2 order-md-1
          "
        >
          <Login
            titleH2="Do.OmYoga! <br> STUDIO"
            guard="DY"
            clientLink="doom_yoga"
          />
        </div>
        <div
          class="
            col-xl-7 col-lg-7 col-md-6 col-sm-12
            my-md-auto my-1
            order-1 order-md-2
          "
          id="doomYogaImdColDiv"
        >
          <div class="container text-center" id="doomYogaImdDiv">
            <img
              class="img-fluid mx-auto"
              id="doomYogaLoginImg"
              src="@/assets/images/doom-yoga/doom-yoga-login-image2.png"
              alt="doomyoga Logo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "@/components/auth/Login";

export default {
  name: "DoOmYogaLogin",
  components: { Login },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onSubmit() {
      console.log("submit login");
    },
  },
};
</script>
<style  scoped::v-deep>
@import "../css/doom-yoga-fonts.css";
@import "../css/doom-yoga-auth-styles.css";
</style>



// WEBPACK FOOTER //
// src/components/doom_yoga/auth/LoginView.vue